export default {
    "AT": {
        message: "Wie verwenden Cookies, um unsere Webseite optimal für Sie gestalten und fortlaufend verbessern zu können.",
        button1: "Details anzeigen",
        button2: "Zustimmen"
    },
    "CH": {
        message: "Ce site utilise des cookies pour vous offrir une meilleure expérience utilisateur.",
        button1: "Plus d'informations",
        button2: "J’accepte"
    },
    "DE": {
        message: "Wie verwenden Cookies, um unsere Webseite optimal für Sie gestalten und fortlaufend verbessern zu können.",
        button1: "Details anzeigen",
        button2: "Zustimmen"
    },
    "BE": {
        message: "Wij gebruiken cookies om u de best mogelijke ervaring te geven.",
        button1: "Meer informatie",
        button2: "Accepteren"
    },
    "ES": {
        message: "Utilizamos cookies propias y de terceros para mejorar nuestros servicios.",
        button1: "Más info",
        button2: "Aceptar"
    },
    "FR": {
        message: "Ce site utilise des cookies pour vous offrir une meilleure expérience utilisateur.",
        button1: "Plus d'informations",
        button2: "J’accepte"
    },
    "UK": {
        message: "This website uses cookies to ensure you get the best experience.",
        button1: "Learn more",
        button2: "Accept"
    },
    "IT": {
        message: "Questo sito utilizza cookie tecnici e di profilazione propri e di terze parti per offrirle una migliore esperienza.",
        button1: "Ulteriori informazioni",
        button2: "Accetto"
    },
    "NL": {
        message: "Wij gebruiken cookies om u de best mogelijke ervaring te geven.",
        button1: "Meer informatie",
        button2: "Accepteren"
    }
}
